import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation, useNavigate } from "react-router-dom";
import { getReplacedDetailedTaView } from "../../../redux/features/srtSlice";

const TrtTaview = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");
  const projectId = searchParams.get("projectId");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const [selectedTutor, setSelectedTutor] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { trdetailedTaview, loading } = useSelector((state) => state.srt);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const GridHead = [
    { field: "slNo", headerName: "Sl No", width: 80 },
    { field: "trainerName", headerName: "Tutor Name", width: 200 },
    {
      field: "replacementCount",
      headerName: "Replaced Count",
      width: 200,
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <Button
            sx={{
              background:
                "linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))",
              },
              px: "10px",
            }}
            onClick={() => {
              navigate(
                `/my-workspace/trt-studentdetails?fromDate=${fromDate}&toDate=${toDate}&trainerId=${params.row.trainerId}&projectId=${projectId}`
              );
            }}
          >
            View Report
          </Button>
        );
      },
    },
  ];

  const data = {
    projectId: projectId,
    page: pageNum,
    limit: gridSize,
    fromDate: fromDate,
    toDate: toDate,
  };

  useEffect(() => {
    dispatch(getReplacedDetailedTaView(data));
  }, [pageNum, gridSize, fromDate, toDate, projectId]);

  return (
    <GlobalWrapper title={"Replacement Details"}>
      <Box sx={{ display: "flex", mb: 1, gap: "10px", flexDirection: "row" }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {/* <GlobalMultiSelectNew
          disabled={loading}
          label={"Tutor"}
          arrayState={selectedTutor}
          arraySetState={setSelectedTutor}
          data={tutorslist}
          keys={{ id: "name", value: "name" }}
        /> */}
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={GridHead}
          rows={trdetailedTaview.data}
          meta={trdetailedTaview?.meta?.totalRecords || 0}
          rowUniqueId="trainerId"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TrtTaview;
